import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal, EASE } from "@/components/landing/Reveal";
import { DEMO_URL } from "@/config";

const SHOTS = [
  {
    src: "https://static.prod-images.emergentagent.com/jobs/28ad20f8-a5a1-42d8-8b41-1b8aa783b0db/images/a163ab41e3cd0b62dcbe72ec00272fe009f78970767e29e541fd96584b653027.jpeg",
    alt: "Bible reader in Matthew with tap-a-word Strong's word study",
    caption: "Tap any word for Strong's study",
    lift: "lg:-translate-y-8",
  },
  {
    src: "https://static.prod-images.emergentagent.com/jobs/28ad20f8-a5a1-42d8-8b41-1b8aa783b0db/images/9bd2b8fdf78f1713bbf51426ada29cf3b065a9c3bc84b3df16309a32f9025a4f.jpeg",
    alt: "Notes with @ Scripture phrase search and matching verses",
    caption: "Type @ to search Scripture and add it directly to your note",
    lift: "lg:translate-y-4",
  },
  {
    src: "https://static.prod-images.emergentagent.com/jobs/28ad20f8-a5a1-42d8-8b41-1b8aa783b0db/images/98f1088efc7260b232531a3963dd2f31e1f7b7449384c72295fee4284fbaffa1.jpeg",
    alt: "Praying-for list with answered prayers",
    caption: "Watch prayers become testimonies",
    lift: "lg:-translate-y-4",
  },
];

export const Demo = () => (
  <section id="demo" className="relative py-16 md:py-24">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8">
        <Reveal>
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-green-dark mb-4">
            Live Now
          </p>
          <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-ink max-w-2xl text-balance">
            Explore The Working Demo.
          </h2>
          <p className="mt-6 max-w-xl text-lg text-ink/70 leading-relaxed">
            A Bible reader in multiple translations with tap-a-word Greek word
            study, and a prayer journal where typing <span className="font-serif italic text-green-dark">@</span> searches
            Scripture as you write.
          </p>
        </Reveal>

        <Reveal delay={0.1}>
          <a
            href={DEMO_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="demo-try-btn"
            className="group inline-flex items-center gap-2 rounded-full bg-green px-8 py-4 text-base font-semibold text-white hover:bg-green-dark transition-colors duration-300 whitespace-nowrap"
          >
            Try the demo
            <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={2} />
          </a>
        </Reveal>
      </div>

      <div className="mt-16 grid grid-cols-1 sm:grid-cols-3 gap-6 md:gap-8">
        {SHOTS.map((s, i) => (
          <motion.div
            key={s.caption}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 1, ease: EASE, delay: i * 0.12 }}
            className={`relative ${s.lift}`}
            data-testid={`demo-shot-${i}`}
          >
            <div className="absolute -inset-4 rounded-[2rem] bg-green/5 blur-2xl" />
            <div className="relative rounded-[1.75rem] border-[5px] border-ink bg-ink p-1 shadow-xl hover:-translate-y-2 transition-transform duration-500">
              <img src={s.src} alt={s.alt} className="w-full rounded-[1.4rem] object-cover" loading="lazy" />
            </div>
            <p className="mt-4 text-center text-sm font-medium text-ink/60">{s.caption}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
